<template lang="pug">
    div(style="border:0px solid; " class="stock-overview-container")
        div(style="display: flex; justify-content: space-between")
            div(class="" style="width:66%; border: 0px solid;")
                div(class="chart" style="position:relative; height:100%; z-index: 0; overflow:hidden; border:1px solid lightgrey;")
                    ChartPrice(:stock_id='stock.stock_id'
                               :company_id='company_id'
                               :legendView="false"
                               :single="true"
                               :leftToolbar="false"
                               :showrightSideBarLine="false"
                               page="mainOverview"
                               style="height:100%; width:100%; border:0px solid red")
            div(class="chart-series" style="width:30%; border:0px solid;")
                SparkLine(:label="'EPS'" :company_id="company_id" class="")
                SparkLine(:label="'P/E'" :company_id="company_id" class="")
                SparkLine(:label="'S'" :company_id="company_id" class="")
                SparkLine(:label="'P/S'" :company_id="company_id" class="")
                SparkLine(:label="'SΔ%'" :company_id="company_id" class="")
                SparkLine(:label="'PM%'" :company_id="company_id" class="")

        div(class="mt-8" style="display:flex; justify-content:space-between")
            //div(style="width:100%; height:100%; background-color:white; border:0px solid;")
            div(class="" style="width:40%; font-size:13px; line-height: 18px; border:0px solid;")
                img(:src="logoURL" style="float:right; width:70px; margin:5px 5px 5px 15px; border:0px solid;")
                div(v-if="$i18n.locale === 'en'" style="display: table") {{ company.description.substring(0,700) }}
                div(v-if="$i18n.locale === 'sv'" style="display: table") {{ company.description_sv.substring(0,700) }}

            div(class="" style="width:35%;padding: 0 0 0 48px; border:0px solid;")
                div(class="stck-overview-market-label")
                    label() {{ $t('market_cap') }}:
                        span(v-if="format(marketCap) !== '0'" class="euroMillions") {{ format(marketCap.toFixed(0)) }}
                        span(v-else) N/A
                    label() {{ $t('EV_EBIT') }}:
                        span() {{ !isNaN(latestReport.ev_ebit.toFixed(2)) ? latestReport.ev_ebit.toFixed(2) : 'N/A' }}
                    label() {{ $t('yield') }}:
                        span() {{ !isNaN(latestReport.yield.toFixed(1)) ? `${latestReport.yield.toFixed(1)}%` : 'N/A' }}
                    label() {{ $t('Exchange') }}:
                        span() {{ exchangeData.name }}, {{ exchangeData.country }}
                    label() {{ $t('theme_latest_reports') }}:
                        span() {{ company.last_report_date !== null ? company.last_report_date : 'N/A' }}
                    label() {{ $t('next_report') }}:
                        span() {{ company.next_report_date !== null ? company.next_report_date : 'N/A' }}

            div(style="width:25%; padding: 0 0 0 12px; border:0px solid;")
                div(style="height:195px;border:0px solid;")
                    div(style="font-size: 13px; font-weight: 600; color:rgba(0,0,0,.5);display:flex;align-items:center; justify-content:space-between; padding-bottom: 8px")
                        div() {{ $t(sectorName) }}
                        div() Mkt&nbsp;Cap
                    div(style="height:150px; width:100%; overflow-y:scroll; overflow-x:hidden;")
                        div(v-for="(item, index) in stocksInSector" style="width:100%; padding:4px 0; border-top:1px solid #f4f4f4; display:flex;align-items:center; justify-content:space-between")
                            div()
                                Ticker(:stockId="item.stock_id")
                            img( :src="'/images/flag_' + item.country + '.png'" style="width:26px; margin: 0 12px")
                            div(class="ellipsis" :title="item.name" style="width:50%; margin-right: 12px;border:0px solid;") {{ item.name }}
                            div(style="width:50px; text-align: right") {{item.market_cap !== null ? item.market_cap : 'N/A'}}
</template>

<script>
/* eslint-disable no-console */
import { mapGetters } from "vuex";
import ChartPrice from "@/components/ChartPrice.vue";
import CanvasEPS from "@/views/stock/CanvasEPS.vue";
import CanvasPE from "@/views/stock/CanvasPE.vue";
import CanvasRevenue from "@/views/stock/CanvasRevenue.vue";
import CompanyInformation from "@/views/stock/CompanyInformation";
import CompanyPdfTable from "@/views/stock/CompanyPdfTable";
import Ticker from "../../components/Ticker.vue";
import SparkLine from '@/components/SparkLine';

export default {
    name: "StocksOverview",
    components: {
        CompanyInformation,
        CompanyPdfTable,
        ChartPrice,
        CanvasEPS,
        CanvasPE,
        CanvasRevenue,
        Ticker,
        SparkLine
    },
    props: {company_id: Number, stock: Object},
    computed: {
        ...mapGetters([
            "getAllCompanies",
            "getAllStocks",
            "getMapStocks",
            "getMapExchanges",
            "getAllSectors",
            "getLatestReport",
            "getCompany",
            "getMapCompanies"
        ]),
        latestReport() {
            return this.getLatestReport(this.company_id);
        },
        stock_id() {
            return this.stock.stock_id;
        },
        company() {
            return this.getCompany(this.company_id);
        },
        stockData() {
            return this.getMapStocks.find(s => s.stock_id == this.stock_id);
        },
        marketCap() {
            // console.log('step 1');

            const latestCompanyReport = this.latestReport;

            // console.log('step 2');
            // console.log(latestCompanyReport);

            const totalnumberofshares = latestCompanyReport.totalnumberofshares !== undefined ? latestCompanyReport.totalnumberofshares : 0;

            // console.log('step 3');
            // console.log(totalnumberofshares);

            const price = latestCompanyReport.price !== undefined ? latestCompanyReport.price : 0;

            // console.log('step 4');
            // console.log(price);

            const currency = latestCompanyReport.currency !== undefined ? latestCompanyReport.currency : '';

            // console.log('step 5');
            // console.log(currency);

            const dividedBy = currency !== '' ? this.currencyRate(currency) * 1000000 : 0;

            // console.log('step 6');
            // console.log(dividedBy);

            const marketCap = !isNaN(((price * totalnumberofshares) / dividedBy)) ? (price * totalnumberofshares) / dividedBy : '';

            // console.log('step 7');
            // console.log(marketCap);

            return marketCap !== '' ? marketCap : '';
        },
        stocksInSector() {
            let stock_data = this.getMapStocks.find(s => s.stock_id == this.stock_id);
            let stocksInSector = [];
            this.getAllStocks.forEach(s => {
                if (s.sector_id === stock_data.sector_id) {
                    const c = this.getAllCompanies.get(s.company_id);
                    const sx = this.getMapExchanges.get(s.stock_exchange_id);
                    if (c) {
                        s.last_report_date = c.last_report_date;
                        s.market_cap = c.market_cap;
                        s.country = (sx) ? sx.country: '';
                        stocksInSector.push(s);
                    }
                }
            });
            return stocksInSector;
        },
        exchangeData() {
            const stock_exchange_id = this.stockData.stock_exchange_id;
            const exchangeData = this.getMapExchanges.get(stock_exchange_id);

            return exchangeData;
        },
        sectorName() {
            const sector_id = this.stockData.sector_id;
            const sectorName = this.getAllSectors.find((s) => s.id === sector_id).name;

            return sectorName;
        },
        logoURL() {  // display logo if it exists....
            let logo_url = "/images/logos/senofidk/" + this.stockData.company_id + ".png"
            var xhr = new XMLHttpRequest();
            xhr.open('HEAD', logo_url, false);
            xhr.send();

            if (xhr.status === "404") {
                console.log("File doesn't exist");
                return false;
            } else {
                console.log("File exists");
                return logo_url;
            }
        }
    },
    // mounted() {
    //     // console.log(this.company_id);
    //     // console.log(this.company);
    //     // console.log(this.latestReport);
    //     console.log(this.getMapCompanies);
    //     console.log(this.format(this.marketCap));
    // },
    methods: {
        format(x) {
            return new Intl.NumberFormat('sv-SE').format(x);
        },
        currencyRate(currency) {
            return this.rates.find((r) => r.currency === currency).rate;
        }
    },
    data() {
        return {
            rates: [
                { currency: 'EUR', rate: 1.00 },
                { currency: 'SEK', rate: 11.10 },
                { currency: 'NOK', rate: 10.69 },
                { currency: 'DDK', rate: 7.44 },
            ]
        };
    }
}
</script>

<style scoped>

.stck-overview-market-label {

}

.stck-overview-market-label label {
    display: flex;
    font-size: 13px;
    justify-content: space-between;
    padding: 0 0 8px 0;
}

.stck-overview-market-label label span {
    width: 65%;
}


.ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
}

.ellipsis3 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 90px;
    display: inline-block;
}

.ellipsis2 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
}

::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    opacity: 0;
}

>>> .peers th.text-right .peers th.text-left {
    padding: 0;
    background: #eeeecc;
}

>>> .peers td.text-right {
    padding: 0;
}

>>> .peers td.text-left {
    padding: 0;
}

>>> .v-data-table th {
    font-size: 1em !important;
    padding-left: 5px !important;
}

>>> .v-data-table td {
    font-size: 1em !important;
    padding-left: 5px !important;
}

>>> .company-name,
>>> .trading-vue-data-toolbar-company-name,
>>> .trading-vue-data-toolbar-compare,
>>> .trading-vue-line-type,
>>> .trading-vue-legend-group {
    display: none;
}

>>> .trading-vue-data-toolbar-container {
    margin: 12px 0 0 5px;
    position: relative;
}

.euroMillions {
    margin: 0 5px;
}

.euroMillions::before {
    content: "€";
    margin-right: 5px;
}

.euroMillions::after {
    content: "M";
    margin: 0 5px;
}

.chart-series {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.chart-series > div {
    border: 0px solid red !important;
    box-shadow: none !important;
    float: none !important;
    width: 46%;
}

.chart-series > div svg rect {
    fill: #222;
}
</style>
